import { Controller } from "@hotwired/stimulus"

export default class ProfileEditController extends Controller {
  static targets = ["viewMode", "editMode", "editButton", "previewImage"]

  declare viewModeTarget: HTMLElement
  declare editModeTarget: HTMLElement
  declare editButtonTarget: HTMLElement
  declare previewImageTarget: HTMLImageElement

  private originalImageSrc: string | null = null

  toggleEdit(event: Event) {
    event.preventDefault()

    this.originalImageSrc = this.previewImageTarget.src

    this.viewModeTarget.classList.add("d-none")
    this.editModeTarget.classList.remove("d-none")
    this.editButtonTarget.classList.add("d-none")
  }

  cancelEdit(event: Event) {
    event.preventDefault()
    this.editModeTarget.classList.add("d-none")
    this.viewModeTarget.classList.remove("d-none")
    this.editButtonTarget.classList.remove("d-none")

    const form = this.editModeTarget.querySelector("form")
    if (form) {
      form.reset()
    }

    if (this.originalImageSrc) {
      this.previewImageTarget.src = this.originalImageSrc
    }
  }

  showViewMode() {
    this.editModeTarget.classList.add("d-none")
    this.viewModeTarget.classList.remove("d-none")
    this.editButtonTarget.classList.remove("d-none")
  }
}
